/**
 * Gemeinsame Domänentypen für Server, Client und Tests.
 * Diese Typen bilden den Vertrag zwischen Frontend und Backend.
 */
export const GOAL_TYPES = [
    'world_east',
    'world_west',
    'europe_countries',
    'top_islands',
    'antipode',
    'antipode_world',
    'top_airlines',
    'free',
];
export const DEFAULT_ROUND_OPTIONS = {
    forbiddenTopXAirports: 0,
    uniqueAirportsOnly: false,
    failProbability: 2 / 3,
    minLayoverMinutes: 40,
    changeCutoffMinutes: 30,
    topX: 5,
    customGoalText: null,
};
//# sourceMappingURL=types.js.map